import { render, staticRenderFns } from "./protocol-common.vue?vue&type=template&id=0f5d4ae2&scoped=true&"
import script from "./protocol-common.vue?vue&type=script&lang=js&"
export * from "./protocol-common.vue?vue&type=script&lang=js&"
import style0 from "./protocol-common.vue?vue&type=style&index=0&id=0f5d4ae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d4ae2",
  null
  
)

export default component.exports